export class EmailTemplateProcessingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSpecialLinks() {
    return this.#http.get(`/email-template-processing/special-links`);
  }

  async getRenderedTemplateForContact({ templateId, categoryId, contactId }) {
    return this.#http.get(
      `/contact/${contactId}/email-template/${templateId}/generate?categoryId=${categoryId}`,
    );
  }
}
